/**
 * OI Charts service — talks to /api/v1/oi-charts/* (see app.api.v1.oi_charts).
 * Sibling to optionIndicatorService, never modifying it.
 */
import api from "@/services/api";
import type { BackfillJobStatusResponse, ChartHistoryResponse, EnsureHistoricalResponse } from "@/types";

export const oiChartsService = {
  async getHistory(symbol: string, limit = 150, tradeDate?: string): Promise<ChartHistoryResponse> {
    const { data } = await api.get<ChartHistoryResponse>(`/oi-charts/${symbol}/history`, {
      params: { limit, ...(tradeDate ? { trade_date: tradeDate } : {}) },
    });
    return data;
  },

  // Option Indicator Phase D (OI Flow historical mode) -- explicitly
  // (re)check/trigger a backfill for one historical trade_date without
  // fetching chart points. `getHistory` above already triggers this
  // automatically when needed; this is for an explicit "retry" action
  // (e.g. after a FAILED job) from the UI.
  async ensureHistorical(symbol: string, tradeDate: string): Promise<EnsureHistoricalResponse> {
    const { data } = await api.post<EnsureHistoricalResponse>(
      `/oi-charts/${symbol}/ensure-historical`,
      null,
      { params: { trade_date: tradeDate } },
    );
    return data;
  },

  async getBackfillStatus(jobId: string): Promise<BackfillJobStatusResponse> {
    const { data } = await api.get<BackfillJobStatusResponse>(`/oi-charts/backfill-status/${jobId}`);
    return data;
  },
};

export default oiChartsService;
